export const API_URL = process.env.REACT_APP_API_URL;
export const IMAGE_URL = process.env.REACT_APP_IMAGE_URL;

export const OriginTypes = {
	POST_PAGE: 'postList',
	PROFILE_PAGE: 'profilePagePostList',
	CATEGORY_PAGE: 'categoryPagePostList',
	MONITORED_SOURCE_PAGE: 'monitoredSourcePostList',
	QUERY_PAGE: 'queryPagePostList'
};

export const ModalTypes = {
	EXTRA_SMALL: 'extraSmall',
	SMALL: 'small',
	MEDIUM: 'medium',
	LARGE: 'large',
	RESPONSIVE: 'responsive'
};

export const PageTypes = {
	LOGIN_PAGE: { path: '/login', pageName: 'login' },
	SIGN_UP_PAGE: { path: '/sign-up', pageName: 'sign up' },
	SETTINGS_PAGE: { path: '/settings', pageName: 'settings' },
	LOGS_PAGE: { path: '/logs', pageName: 'logs' },
	MONITORED_SOURCES: { path: '/monitored-sources' },
	QUERIES: { path: '/queries' },
	PROFILES: { path: '/profiles' },
	CATEGORIES: { path: '/categories' },
	SITES: { path: '/sites' },
	POSTS: { path: '/posts' },
	POST_PAGE: { path: '/post/:id', dynamicPath: id => `/post/${id}` },
	MONITORED_SOURCE_PAGE: {
		path: '/monitored-sources/monitored-source/:id',
		dynamicPath: id => `/monitored-sources/monitored-source/${id}`
	},
	QUERY_PAGE: { path: '/queries/query/:id', dynamicPath: id => `/queries/query/${id}` },
	PROFILE_PAGE: { path: '/profiles/profile/:id', dynamicPath: id => `/profiles/profile/${id}` },
	CATEGORY_PAGE: { path: '/categories/category/:id', dynamicPath: id => `/categories/category/${id}` },
	SITE_PAGE: { path: '/sites/site/:id', dynamicPath: id => `/sites/site/${id}` },
	GLOBAL_CONTENT_PARSE_PATTERN_PAGE: { path: '/global-content-parse-pattern/:id', dynamicPath: id => `/global-content-parse-pattern/${id}` }
};

export const ExternalPageTypes = {
	BOT_BOX_MONITORED_SOURCE: {
		dynamicPath: id => `http://wn-monitoring-botbox2.westeurope.cloudapp.azure.com:14211/provider/?mode=editsrc&pid=47114711&sid=${id}`
	},
	IMPORT_IO_MONITORED_SOURCE: {
		dynamicPath: id => `https://app.import.io/dash/extractors/${id}/settings`
	},
	BOT_BOX_NEW: {
		path: 'http://wn-monitoring-botbox2.westeurope.cloudapp.azure.com:14211/provider/?mode=editsrc&pid=47114711&sid=new'
	}
};

export const SEARCH_DEBOUNCE_MILLISECONDS = 350;

export const ImageFormatTypes = {
	AS_ARRAY: ['.png', '.jpeg', '.jpg', '.gif', 'jfif', 'jif', '.tiff', '.tif'],
	AS_STRING: '.jpeg,.jpg,.png,.gif,.jfif,.jif,.tiff,.tif'
};

export const ButtonTypes = {
	PRIMARY: 'colorPrimary', // BLUE
	NAV: 'colorNav',
	NAV_ACTIVE: 'colorNavActive',
	SECONDARY: 'colorSecondary', // WHITE (or black if inverted),
	TERTIARY: 'colorTertiary',
	IGNORE: 'colorIgnore',
	DARK: 'colorDark',
	WHITE: 'colorWhite',
	FLAT: 'buttonFlat',
	SMALL: 'buttonSmall',
	MEDIUM: 'buttonMedium',
	LARGE: 'buttonLarge',
	CURRENT: 'currentColor',
	ERROR: 'error'
};

export const LinkTypes = {
	PRIMARY: 'colorPrimary', // BLUE
	SECONDARY: 'colorSecondary', // GREY
	TERTIARY: 'colorTetriary', // META GREY
	ERROR: 'colorError' // RED
};

export const BadgeTypes = {
	BLUE: 'colorBadgeBlue',
	ORANGE: 'colorBadgeOrange',
	DARK: 'colorBadgeDark',
	GREY: 'colorBadgeGrey'
};

export const SpinnerTypes = {
	BLUE: 'colorBlue',
	LIGHT_BLUE: 'colorLightBlue',
	WHITE: 'colorWhite',
	GREY: 'colorGrey',
	SMALL: 'small',
	MEDIUM: 'medium',
	LARGE: 'large'
};

export const IconSizes = {
	AUTO: 'iconAuto',
	SMALL: 'iconSmall',
	MEDIUM: 'iconMedium',
	LARGE: 'iconLarge'
};

export const IconTypes = {
	MONITORING_SOURCES: 'iconMonitoringSources',
	MONITORING_PROFILES: 'iconMonitoringProfiles',
	MONITORING_POSTS: 'iconMonitoringPosts',
	MONITORING_CATEGORIES: 'iconMonitoringCategories',
	MONITORING_QUERIES: 'iconMonitoringQueries',
	MONITORING_SITES: 'iconMonitoringSites',
	MONITORING_LOGS: 'iconMonitoringLogs',
	MONITORING_LOG_ERROR_INCREASE: 'iconMonitoringLogErrorIncrease',
	MONITORING_LOG_ERROR_DECREASE: 'iconMonitoringLogErrorDecrease',
	MONITORING_LOG_ERROR_CONSUME: 'iconMonitoringLogErrorConsume',
	MONITORING_LOG_ERROR_FETCH: 'iconMonitoringLogErrorFetch',
	ADD_CHART: 'iconAddChart',
	ADD_FILLED: 'iconAddFilled',
	ADD_OUTLINED: 'iconAddOutlined',
	ADD_CATEGORY: 'iconAddCategory',
	ADD_SECTION_ABOVE: 'iconAddSectionAbove',
	ADD_SECTION_BELOW: 'iconAddSectionBelow',
	ARROW_DOWN: 'iconArrowDown',
	ARROW_FIRST_PAGE: 'iconArrowFirstPage',
	ARROW_LAST_PAGE: 'iconArrowLastPage',
	ARROW_LEFT: 'iconArrowLeft',
	ARROW_RIGHT: 'iconArrowRight',
	ARROW_UP: 'iconArrowUp',
	ATTACHMENT: 'iconAttachment',
	BENCHMARKS: 'iconBenchMarks',
	BLOCK: 'iconBlock',
	CARD_MODE: 'iconCardMode',
	CHANGE_ORDER: 'iconChangeOrder',
	CHECK: 'iconCheck',
	CHECK_CIRCLE_LARGE: 'iconCheckCircleLarge',
	CHECK_CIRCLE_SMALL: 'iconCheckCircleSmall',
	CHECK_INDETERMINATE: 'iconCheckIndeterminate',
	CHEVRON_DOWN: 'iconChevronDown',
	CHEVRON_LEFT: 'iconChevronLeft',
	CHEVRON_RIGHT: 'iconChevronRight',
	CHEVRON_UP: 'iconChevronUp',
	CLUSTER: 'iconCluster',
	COG_WHEEL: 'iconCogWheel',
	COMMENT: 'iconComment',
	COMPARE: 'iconCompare',
	CREATE_NEWSLETTER: 'iconCreateNewsletter',
	CROSS: 'iconCross',
	CROSS_CIRCLE_LARGE: 'iconCrossCircleLarge',
	CROSS_CIRCLE_SMALL: 'iconCrossCircleSmall',
	CROSS_CIRCLE_SMALL_FILLED: 'iconCrossCircleSmallFilled',
	DASHBOARD: 'iconDashboard',
	DATE_RANGE: 'iconDateRange',
	DESKTOP: 'iconDesktop',
	DOTS: 'iconDots',
	DOTS_BACKGROUND: 'iconDotsBackground',
	DOT_FILLED: 'iconDotFilled',
	DOT_OUTLINED: 'iconDotOutlined',
	DOWNLOAD: 'iconDownload',
	DUPLICATE: 'iconDuplicate',
	EDIT: 'iconEdit',
	EXPAND: 'iconExpand',
	EXPAND_ARROWS: 'iconExpandArrows',
	FILTER: 'iconFilter',
	FILTER_SETTINGS: 'iconFilterSettings',
	FORMAT_IMAGE_BOTTOM: 'iconFormatImgBottom',
	FORMAT_IMAGE_CENTER_CENTER: 'iconFormatImgCenterCenter',
	FORMAT_IMAGE_CROP: 'iconFormatImgCrop',
	FORMAT_IMAGE_HERO: 'iconFormatHerot',
	FORMAT_IMAGE_LEFT: 'iconFormatImgLeft',
	FORMAT_IMAGE_LEFT_BOTTOM: 'iconFormatImgLeftBottom',
	FORMAT_IMAGE_RIGHT: 'iconFormatImgRight',
	FORMAT_IMAGE_RIGHT_BOTTOM: 'iconFormatImgRightBottom',
	FORMAT_IMAGE_TOP: 'iconFormatImgTop',
	FORMAT_TEXT_ALIGN_CENTER: 'iconFormatTextAlignCenter',
	FORMAT_TEXT_ALIGN_LEFT: 'iconFormatTextAlignLeft',
	FORMAT_TEXT_ALIGN_RIGHT: 'iconFormatTextAlignRight',
	GRID_MODE: 'iconGridMode',
	HANDLEBAR: 'iconHandleBar',
	HELP: 'iconHelp',
	HISTORY: 'iconHistory',
	INBOX: 'iconInbox',
	INDENT: 'iconIndent',
	LIKE: 'iconLike',
	LOGIN: 'iconLogin',
	LOGOUT: 'iconLogout',
	LIKE_FILLED: 'iconLikeFilled',
	LINK: 'iconLink',
	LINK_EXTERNAL: 'iconLinkExternal',
	LIST_MODE: 'iconListMode',
	LOCK: 'iconLock',
	MAIL: 'iconMail',
	MASONRY: 'iconMasonry',
	MENU: 'iconMenu',
	MINIMIZE_ARROWS: 'iconMinimizeArrows',
	MINUS: 'iconMinus',
	MOVIE: 'iconMovie',
	NAVIGATE_DOWN_LARGE: 'iconNavigateDownLarge',
	NAVIGATE_LEFT_LARGE: 'iconNavigateLeftLarge',
	NAVIGATE_RIGHT_LARGE: 'iconNavigateRightLarge',
	NEWSLETTER_CLOSED: 'iconNewsLetterClosed',
	NEWSLETTER_OPENED: 'iconNewsLetterOpened',
	NOTIFICATION: 'iconNotification',
	PALETTE: 'iconPalette',
	PAUSE_CIRCLE: 'iconPauseCircle',
	PDF: 'iconPdf',
	PENCIL: 'iconPencil',
	PHONE: 'iconPhone',
	PHOTO: 'iconPhoto',
	PIN: 'iconPin',
	PLAY: 'iconPlay',
	PLAY_CIRCLE: 'iconPlayCircle',
	PLAY_FLIPPED: 'iconPlayFlipped',
	PLUS: 'iconPlus',
	PPT: 'iconPpt',
	PRESENT: 'iconPresent',
	PREVIEW: 'iconPreview',
	PROFILE: 'iconProfile',
	RENEW: 'iconRenew',
	REPORT: 'iconReport',
	REPORT_LIBRARY: 'iconReportLibrary',
	RESET: 'iconReset',
	REMOVE_CATEGORY: 'iconRemoveCategory',
	SCHEDULE: 'schedule',
	SEARCH: 'iconSearch',
	SEND: 'send',
	SETTINGS_FILLED: 'iconSettingsFilled',
	SETTINGS_OFF: 'iconSettingsOff',
	SETTINGS_OUTLINED: 'iconSettingsOutlined',
	SHARE: 'iconShare',
	SORT: 'iconSort',
	STATISTICS: 'iconStatistics',
	SUBSCRIPTIONS: 'iconSubscriptions',
	SUMMARIZE: 'SUMMARIZE',
	TRANSLATE: 'iconTranslate',
	TRASH: 'iconTrash',
	UNFOLD_LESS: 'iconUnfoldLess',
	UNFOLD_MORE: 'iconUnfoldMore',
	USER: 'iconUser',
	USERS: 'iconUsers',
	USERS_ADD: 'iconUsersAdd',
	USER_REMOVE: 'iconUserRemove',
	VISIBILITY_OFF: 'iconVisibilityOff',
	VISIBILITY_ON: 'iconVisibilityOn',
	WARNING: 'iconWarning',
	ERROR: 'iconError'
};

export const InputTypes = {
	SMALL: 'inputTypeSmall', // 36px high
	MEDIUM: 'inputTypeMedium', // 40px high,
	LARGE: 'inputTypeLarge' // 48px high
};

// NOTE keep snake case for easier handling in the .scss file
export const GridTypes = {
	SPACE_BETWEEN: 'space_between',
	FLEX_DIRECTION_COLUMN: 'flex_direction_column',
	FLEX_DIRECTION_ROW: 'flex_direction_row',
	GUTTER_SMALL: 'gutter_small', // 4px
	GUTTER_MEDIUM: 'gutter_medium', // 8px
	GUTTER_LARGE: 'gutter_large', // 16px,
	GUTTER_EXTRA_LARGE: 'gutter_extra_large' // 24px,
};

export const AppColors = {
	TRANSPARENT: 'transparent',
	WHITE: '#ffffff',
	BLUE: '#0069c1',
	LIGHT_BLUE: '#129dfa',
	GREEN: '#058736',
	RED: '#d0341b',
	ORANGE: '#ff8f00',
	YELLOW: '#ffc107',
	RSS: '#f1b355',
	GREY_1: '#f1f1f1',
	GREY_2: '#dbdbdb',
	GREY_3: '#a2a4a6',
	GREY_4: '#707070',
	GREY_5: '#464646',
	GREY_6: '#2b2f3e',
	GREY_7: '#19191a',
	BLACK: '#000000',
	CUSTOM: 'custom'
};

export const ChartColors = {
	MONITORING_STATISTICS: [AppColors.YELLOW, AppColors.GREEN, AppColors.RED, AppColors.BLUE, AppColors.BLACK, AppColors.GREY_5]
};

export const PostTypes = {
	POST: 'POST',
	WORKSPACE_POST: 'WORKSPACE_POST'
};


export const MonitoredSourceStatusTypes = {
	WARNING: 'WARNING',
	ERROR: 'ERROR',
	OK: 'OK',
	INCREASE: 'INCREASE',
	DECREASE: 'DECREASE',
	CONSUME: 'CONSUME',
	FETCH: 'FETCH'
};

export const TypeNames = {
	MONITORED_SOURCE: 'MonitoredSource',
	MONITORED_SOURCE_LOG: 'MonitoredSourceLog',
	CATEGORY: 'Category',
	SITE: 'Site',
	TAG: 'TAG',
	PROFILE: 'Profile',
	QUERY: 'LuceneQuery',
	LANGUAGES: 'Languages',
	SOURCE_PACK: 'SourcePack',
	CATEGORY_QUERY: 'CategoryQuery',
	ADJACENT_CATEGORY: 'AdjacentCategory',
	PERIPHERAL_CATEGORY: 'PeripheralCategory',
	SOURCE_NAME: 'SourceName',
	PORTAL: 'Portal'
};

export const TimePeriodTypes = {
	ANY_TIME: '0',
	ONE_DAY: '1,DAY',
	ONE_WEEK: '1,WEEK',
	ONE_MONTH: '1,MONTH',
	ONE_YEAR: '1,YEAR',
	CUSTOM_RANGE: '1'
};

export const TemplateTypes = {
	GLOBAL: 'global',
	PORTAL: 'portal'
};

export const OpenOriginTypes = {
	TOP_LEFT: 'topLeft',
	TOP_CENTER: 'topCenter',
	TOP_RIGHT: 'topRight',
	CENTER_CENTER: 'centerCenter',
	BOTTOM_LEFT: 'bottomLeft',
	BOTTOM_CENTER: 'bottomCenter',
	BOTTOM_RIGHT: 'bottomRight'
};
